"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
exports.__esModule = true;
exports.getReactedCopyOfNode = exports.createReactivePlugin = void 0;
var prosemirror_state_1 = require("prosemirror-state");
var prosemirror_view_1 = require("prosemirror-view");
var documentStore_1 = require("../store/documentStore");
var util_1 = require("../store/util");
var key_1 = require("./key");
var nodeViews_1 = require("./nodeViews");
var createReactiveDecorationForNode = function (from, to, cycleId, count) {
    return prosemirror_view_1.Decoration.node(from, to, {}, { "reactive-update": cycleId + "-" + count });
};
exports.createReactivePlugin = function (_a) {
    var idAttrKey = _a.idAttrKey, schema = _a.schema, _b = _a.documentState, documentState = _b === void 0 ? {} : _b;
    var editorView = null;
    var getInvalidatedNode = function (transaction) {
        var reactiveTransaction = transaction.getMeta(key_1.reactivePluginKey);
        if (reactiveTransaction) {
            var invalidatedNode = reactiveTransaction.invalidatedNode;
            if (invalidatedNode) {
                return invalidatedNode;
            }
        }
        return null;
    };
    var invalidateNode = function (node) {
        if (editorView) {
            var transaction = editorView.state.tr;
            transaction.setMeta(key_1.reactivePluginKey, { invalidatedNode: node });
            editorView.dispatch(transaction);
        }
        else {
            util_1.warn("Dispatching an invalidation transaction for Node {nodeId} before the editor was initialized");
        }
    };
    var store = new documentStore_1.DocumentStore({
        nodeSpecs: schema.nodes,
        invalidateNode: invalidateNode,
        idAttrKey: idAttrKey,
        documentState: documentState
    });
    var getDecorationSetForDoc = function (doc, cycleId) {
        var decorations = [];
        var invalidatedRanges = store.run(doc);
        for (var invalidatedId in invalidatedRanges) {
            var _a = __read(invalidatedRanges[invalidatedId], 2), from = _a[0], to = _a[1];
            var decoration = createReactiveDecorationForNode(from, to, cycleId, decorations.length);
            decorations.push(decoration);
        }
        return prosemirror_view_1.DecorationSet.create(doc, decorations);
    };
    return new prosemirror_state_1.Plugin({
        key: key_1.reactivePluginKey,
        view: function (view) {
            editorView = view;
            editorView.update(__assign(__assign({}, view.props), { nodeViews: __assign(__assign({}, view.props.nodeViews), nodeViews_1.createReactiveNodeViews(view, schema, store)) }));
            return {
                update: function (nextView) {
                    editorView = nextView;
                }
            };
        },
        props: {
            decorations: function (editorState) {
                return key_1.reactivePluginKey.getState(editorState).decorations;
            }
        },
        state: {
            init: function (_, editorState) {
                return {
                    store: store,
                    decorations: getDecorationSetForDoc(editorState.doc, Date.now())
                };
            },
            apply: function (transaction, pluginState, editorState) {
                var cycleId = Date.now();
                var invalidatedNode = getInvalidatedNode(transaction);
                if (transaction.docChanged) {
                    return __assign(__assign({}, pluginState), { decorations: getDecorationSetForDoc(transaction.doc, cycleId) });
                }
                else if (invalidatedNode) {
                    var decoration_1;
                    editorState.doc.descendants(function (node, offset) {
                        if (store.compareNodesById(invalidatedNode, node)) {
                            decoration_1 = createReactiveDecorationForNode(offset, offset + node.nodeSize, cycleId, 0);
                        }
                    });
                    if (decoration_1) {
                        return __assign(__assign({}, pluginState), { decorations: prosemirror_view_1.DecorationSet.create(editorState.doc, [decoration_1]) });
                    }
                }
                return pluginState;
            }
        }
    });
};
exports.getReactedCopyOfNode = function (node, editorState) {
    var pluginState = key_1.reactivePluginKey.getState(editorState);
    if (pluginState) {
        var store = pluginState.store;
        return store.getReactedCopy(node);
    }
    return null;
};
